import React from 'react';

export default ({listGallery, baseURL}) => {
  return (
    <section className="akun-saya" style={{ borderBottom: 'none'}}>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'stretch', marginLeft: '90px', marginRight: '30px'}}>
        {listGallery.length ? listGallery.map(e => (<div style={{width: '350px', marginRight: '15px', marginLeft: '15px'}}>
          <div className="embed-responsive embed-responsive-16by9 mb-4" style={{borderRadius: '5px'}}>
            <iframe className="embed-responsive-item" src={e.url} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""/>
          </div>
        </div>)) : <div>No data founded</div>}
      </div>
    </section>
  )
}